export const segregatedChinaCategories = [
  'Drones',
  'Gadgets',
  'Appliance',
  'Medication',
  'BeautyProducts',
  'BatteryLiquidElectrical&PowderItems'
];
export const segregatedCountries = ['Uganda', 'Cameroon', 'Cote D"Ivoire'];
export const segregatedSaverCountries = ['France', 'Italy', 'Paris'];
